// Auto-generated by scripts/generate-registry.mjs from packages/modules/name_clicker/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const name_clicker: ModuleSchema = {
  "id": "name_clicker",
  "uniqueId": "B3D_4ZOAZ",
  "createdAt": "2026-10-01T00:00:00Z",
  "updatedAt": "2026-10-28T14:58:34.430Z",
  "label": "Name Clicker",
  "description": "Custom text nameplate fidget clicker with an MX switch socket, built from the core text and mx_switch primitives",
  "category": "fidget",
  "tags": [
    "fidget",
    "name",
    "text",
    "keychain",
    "switch"
  ],
  "sliders": [
    {
      "key": "fontSize",
      "label": "Text Height",
      "min": 10,
      "max": 60,
      "default": 25,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "letterSpacing",
      "label": "Letter Spacing",
      "min": -20,
      "max": 50,
      "default": 0,
      "step": 1,
      "unit": "%",
      "enabled": true,
      "visible": true
    },
    {
      "key": "designMargin",
      "label": "Plate Margin",
      "min": 1,
      "max": 10,
      "default": 2.5,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "topThickness",
      "label": "Raised Text Height",
      "min": 0.4,
      "max": 5,
      "default": 2,
      "step": 0.2,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "bottomWallHeight",
      "label": "Plate Height",
      "min": 6,
      "max": 30,
      "default": 18.5,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "switchCount",
      "label": "Switch Count (0 = auto)",
      "min": 0,
      "max": 8,
      "default": 1,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    },
    {
      "key": "switchSize",
      "label": "Switch Socket Size",
      "min": 8,
      "max": 30,
      "default": 14.2,
      "step": 0.2,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [
    {
      "key": "text",
      "label": "Custom Name (Name Text)",
      "default": "BOXED3D",
      "kind": "text",
      "enabled": true,
      "visible": true
    },
    {
      "key": "fontStyle",
      "label": "Font Family",
      "default": "roboto",
      "kind": "font",
      "enabled": true,
      "visible": true
    }
  ],
  "colorConfigs": [
    {
      "key": "base_shell",
      "label": "Base Shell",
      "default": "#2563EB",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "switch_stem",
      "label": "Switch Stem",
      "default": "#DC2626",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "top_cap_shell",
      "label": "Top Cap Shell",
      "default": "#DC2626",
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "text_legend",
      "label": "Embossed Text Legend",
      "default": "#64748B",
      "targetGroupIds": [
        3
      ]
    }
  ],
  "objects": [
    {
      "id": "obj_base",
      "label": "Base Shell Assembly",
      "name": "Base Shell Assembly",
      "color": "#2563EB",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "base_shell",
          "label": "Base Shell",
          "name": "Base Shell",
          "groupId": 0,
          "colorKey": "base_shell",
          "defaultColor": "#2563EB",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "obj_switch",
      "label": "Switch Assembly",
      "name": "Switch Assembly",
      "color": "#DC2626",
      "assembled_z_offset": 0,
      "exploded_z_offset": 30,
      "parts": [
        {
          "id": "switch_stem",
          "label": "Switch Stem",
          "name": "Switch Stem",
          "groupId": 1,
          "colorKey": "switch_stem",
          "defaultColor": "#DC2626",
          "assembled_z_offset": 0,
          "exploded_z_offset": 30,
          "export_stl": true
        }
      ]
    },
    {
      "id": "obj_cap",
      "label": "Top Cap Assembly",
      "name": "Top Cap Assembly",
      "color": "#DC2626",
      "assembled_z_offset": 0,
      "exploded_z_offset": 65,
      "parts": [
        {
          "id": "top_cap_shell",
          "label": "Top Cap Shell",
          "name": "Top Cap Shell",
          "groupId": 2,
          "colorKey": "top_cap_shell",
          "defaultColor": "#DC2626",
          "assembled_z_offset": 0,
          "exploded_z_offset": 65,
          "export_stl": true
        },
        {
          "id": "text_legend",
          "label": "Embossed Text Legend",
          "name": "Embossed Text Legend",
          "groupId": 3,
          "colorKey": "text_legend",
          "defaultColor": "#64748B",
          "assembled_z_offset": 0,
          "exploded_z_offset": 95,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Assembly"
    }
  ]
};
